// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container33 {
  width: 900px;
  background-color: #eee;
}

.entry33 {
  display: grid;
  gap: 1em;
  grid-template-columns: 12em 6em 1fr 2fr;
}

.sub-entries {
  padding-left: calc(1em * var(--depth, 1));
}

/**/
details summary {
  cursor: pointer;

  font-weight: bold;
}

details summary::after {
  content: " ▼";
}

details[open] summary::after {
  content: " ▲";
}

.conciliacion-table td {
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Cobranza/cobranza.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,GAAG;AACH;EACE,eAAe;;EAEf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".container33 {\n  width: 900px;\n  background-color: #eee;\n}\n\n.entry33 {\n  display: grid;\n  gap: 1em;\n  grid-template-columns: 12em 6em 1fr 2fr;\n}\n\n.sub-entries {\n  padding-left: calc(1em * var(--depth, 1));\n}\n\n/**/\ndetails summary {\n  cursor: pointer;\n\n  font-weight: bold;\n}\n\ndetails summary::after {\n  content: \" ▼\";\n}\n\ndetails[open] summary::after {\n  content: \" ▲\";\n}\n\n.conciliacion-table td {\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
